import React from 'react';
import ReactDOM from 'react-dom/client';
import Loader from '@amzn/meridian/loader';

import App from './components/App';
import { AppInitWrapper } from './components/AppInitWrapper';
import './i18n';

import '@amzn/meridian-tokens/base/font/amazon-ember.css';

// The Suspense component causes React to display the fallback Loader until
// the i18n translation strings have been loaded.
const root = ReactDOM.createRoot(document.getElementById('root') as HTMLElement);
root.render(
  <React.StrictMode>
    <AppInitWrapper>
      <React.Suspense fallback={<Loader size="large" />}>
        <App />
      </React.Suspense>
    </AppInitWrapper>
  </React.StrictMode>,
);
